import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/test`;
const pathById = `${pathBase}:testId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const test = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  get: (param: IPathByIdParam) => generatePath(pathById, param),
  patch: (param: IPathByIdParam) => generatePath(pathById, param),
  put: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
